import * as React from "react";

const Measure: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 16 10" enableBackground="new 0 0 16 10" xmlSpace="preserve">
    <path fill="CurrentColor" d="M0,0v10h16V0H0z M15,9H1V1h2v3h1V1h2v5h1V1h2v3h1V1h2v5h1V1h2V9z"/>
    </svg>;
};

export default React.memo(Measure);
